import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const TOOLTIP_BG = '#ffffff';
const TOOLTIP_COLOR = '#000000';
const TOOLTIP_BORDER = '1px solid #e0e0e0';
const TOOLTIP_SHADOW = '0px 2px 4px rgba(0,0,0,0.1)';
const TOOLTIP_FONT_SIZE = '12px';
const TOOLTIP_PADDING = 1;

const LINK_MAX_WIDTH = 330;

const ChangesCell = ({ value }) => {
  if (!value) return 'No Change';

  return (
    <div style={{ whiteSpace: 'pre-line' }}>
      {value.split('\n').map((line, i) => {
        if (!line.includes('URL_START')) return <div key={i}>{line}</div>;

        const parts = line.split(' --> ');
        return (
          <div key={i}>
            {parts.map((part, j) => {
              if (!part.includes('URL_START')) {
                return j > 0 ? <React.Fragment key={j}> {part}</React.Fragment> : <span key={j}>{part}</span>;
              }

              const urlMatch = part.match(/URL_START(.+?)URL_DISPLAY(.+?)URL_END/);
              if (!urlMatch) {
                return j > 0 ? <React.Fragment key={j}> {part}</React.Fragment> : <span key={j}>{part}</span>;
              }

              const fullUrl = urlMatch[1];
              const displayText = urlMatch[2];
              const beforePart = part.split('URL_START')[0];

              return (
                <React.Fragment key={j}>
                  {j > 0 && ' --> '}
                  {beforePart}
                  <Tooltip
                    title={fullUrl}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: TOOLTIP_BG,
                          color: TOOLTIP_COLOR,
                          border: TOOLTIP_BORDER,
                          boxShadow: TOOLTIP_SHADOW,
                          fontSize: TOOLTIP_FONT_SIZE,
                          p: TOOLTIP_PADDING,
                        },
                      },
                    }}
                  >
                    <a
                      href={fullUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: 'none',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                        maxWidth: LINK_MAX_WIDTH,
                      }}
                    >
                      {displayText}
                    </a>
                  </Tooltip>
                </React.Fragment>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ChangesCell;
